export default __webpack_public_path__ + "static/media/promotional.ec9261db.png";